import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import {
	isValidHolderName,
	normalizeHolderNamePart,
} from '../ticketHolderName';

interface ITicketHolderNameCollapsedSummaryProps {
	firstName: string;
	lastName: string;
}

export const TicketHolderNameCollapsedSummary: FC<
	ITicketHolderNameCollapsedSummaryProps
> = ({ firstName, lastName }) => {
	const { t } = useTranslation('ticketshop');
	const isValid = isValidHolderName(firstName, lastName);

	return (
		<Stack component="span" gap={1}>
			{isValid ? (
				<Typography component="span" variant="h4-sb" color="primary">
					{`${normalizeHolderNamePart(firstName)} ${normalizeHolderNamePart(
						lastName
					)}`}
				</Typography>
			) : (
				<Typography component="span" variant="h4-sb" color="error.main">
					{t('ticket_detail.name_change_section.error_collapsed')}
				</Typography>
			)}
			{/* Plain text: the whole section header is already the toggle button */}
			<Typography component="span" variant="l1" color="solutions.600">
				{t('ticket_detail.name_change_section.change')}
			</Typography>
		</Stack>
	);
};
